module.exports = __webpack_public_path__ + "static/media/cpu.506b9607.svg";